(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["olle-giveaway-featured-products"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('[data-giveaway-redeem-form]')) return;
    var code = form.elements.namedItem('discount');
    if (!code) return;
    code.value = code.value.trim();
    if (!code.value || !form.checkValidity()) {
      event.preventDefault();
      form.reportValidity();
    }
  });

  } catch(e) { console.error(e); }
})();
})();
